module.exports = __webpack_public_path__ + "img/wonderpush_help.d223190f.jpg";